import { http, HttpResponse } from 'msw';

import type { GustoCompanyData } from 'services/gusto/queries/useGustoCompany/useGustoCompany.interface';

const baseGustoCompany: GustoCompanyData = {
    id: 1,
    uuid: 'gusto-company-uuid',
    name: 'Acme Co',
    trade_name: null,
    company_status: 'Approved',
    is_suspended: false,
    is_partner_managed: true,
    tier: 'plus',
    entity_type: 'S-Corporation',
    ein: '12-3456789',
};

export default {
    'gusto/getCompany': http.get('*/gusto/companies/', () => HttpResponse.json(baseGustoCompany)),
    'gusto/migrateCompany': http.put('*/gusto/companies/*/migrate/', () => HttpResponse.json({})),
};
